<template>
    <div>
        <div class="detail">
            <div id="exit_modal_wrapper" style="display: none;" @click="exitModalclick"></div>
            <div id="modal_wrapper" style="display: none;" @click="endIntercation"></div>
            <div id="my-custom">
                <el-dialog id="interaction-log" :visible.sync="showInteractionFlag" width="34.6875vw">
                    <div class="interaction-log">
                        <div class="logo"></div>
                        <div class="title">抢答记录</div>
                        <div class="close" @click="showInteractionFlag = false"></div>
                        <div class="list-wrapper">
                            <el-collapse v-model="activeNames" @change="handleChange">
                                <el-collapse-item :name="item.packetPushId" v-for="(item, index) in interactionPushs"
                                    :key="'collapse' + item.packetPushId + item.createTime">
                                    <template slot="title">
                                        <div class="title-container">
                                            <p
                                                :style="{ color: item.correct ? (item.award ? '#FF5A00' : '#B3B3B3') : '#B3B3B3' }">
                                                ({{
                                                    item.message }})</p>
                                            {{ `${item.packetName}` }}
                                        </div>
                                    </template>
                                    <div :style="index == 0 ? { marginTop: '0px' } : {}" class="list-item">
                                        <div class="list-item-content" v-for="(item2, index) in item.questions">
                                            题目：{{ item2.name }}
                                            <el-checkbox-group v-model="item2.selected" :disabled="true">
                                                <div class="intercation_modal__option"
                                                    v-for="(innerItem, innerIndex) in item2.options"
                                                    :key="'inner-' + innerItem.optionId + '' + Math.floor(randomNum(10000))">
                                                    <el-checkbox :label="innerItem.optionId">{{ filterLetter(innerIndex) +
                                                        "." +
                                                        innerItem.description
                                                    }}</el-checkbox>
                                                    <div v-show="innerItem.correct" class="right"></div>
                                                    <div v-show="!innerItem.correct" class="error"></div>
                                                </div>
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>

                        </div>
                    </div>
                </el-dialog>
                <div id="gift_animation"
                    style="position:absolute;top:calc(50% - 150px); left: calc(50% - 150px);display: none;">
                </div>
                <div class="water_animation"
                    :style="{ position: 'absolute', top: '100px', left: '0', width: fontSize * 14 + 'px', height: fontSize * 1.2 + 'px', display: 'none', }">
                </div>
                <div id="intercation_tip_modal_inner" style="display: none;"
                    @click="preemptiveAnswer('intercation_tip_modal_inner')">
                    <div class="intercation_tip__title">有奖答题</div>
                    <div class="intercation_tip__timer">{{ timeDisplay }}</div>
                    <el-button class="intercation_tip__answer">立刻答题</el-button>
                </div>
                <div id="modal_wrapper_full" style="display: none;" @click="endIntercation"></div>
                <div id="intercation_modal" style="display: none;" :class="[1, 4, 3].includes(answerStep) ? '' : 'answer'">
                    <div style="position: relative;width: 100%;height: 100%;">
                        <div class="intercation_modal__close" @click="endIntercation">

                        </div>
                        <div class="title_container">
                            <div class="intercation_modal__title" v-show="[1, 4, 3].includes(answerStep)">
                                {{ interaction.questions[questionIndex].name }}
                            </div>

                            <div class="intercation_modal__title" style="text-align: center;" v-show="answerStep == 2">
                                🎉恭喜获得
                            </div>
                        </div>

                        <!-- <div class="intercation_modal__title" style="text-align: center;" v-show="answerStep == 5">
                                获奖记录
                            </div> -->
                        <div class="intercation_modal__options" v-show="answerStep == 1">
                            <el-checkbox-group v-model="selected" @change="selectedChange">
                                <div class="intercation_modal__option"
                                    v-for="(item, index) in interaction.questions[questionIndex].options"
                                    :key="'get' + item.optionId + '' + Math.floor(randomNum(10000))">
                                    <!-- {{ item.description }} -->
                                    <el-checkbox :label="item.optionId"><span style="margin-right: 6px;">{{
                                        filterLetter(index) + "." }}</span>{{ item.description
    }}</el-checkbox>
                                </div>
                            </el-checkbox-group>

                        </div>
                        <div class="intercation_modal__answer_options" v-show="[3, 4].includes(answerStep)">
                            <div class="intercation_modal__option"
                                v-for="(item, index) in interactionAnswer.questions[questionIndex].options"
                                :key="'answer' + item.optionId + '' + Math.floor(randomNum(10000))">
                                <div v-show="item.correct" class="right"><img :src="img_right" /></div>
                                <div v-show="!item.correct" class="error"><img :src="img_error" /></div>
                                <span :style="{ marginRight: '6px', color: item.selected ? '#FD5000' : 'black' }">{{
                                    filterLetter(index) + "." }}</span>
                                <span :style="{ color: item.selected ? '#FD5000' : 'black' }">{{
                                    item.description }}</span>
                            </div>
                        </div>
                        <div class="intercation_modal__answer_result_change" v-show="[3, 4].includes(answerStep)">
                            <i class="el-icon-arrow-left btn_left" style="margin-right: 30px;" @click="questionIndex--"
                                v-show="questionIndex >= 1"></i>
                            <i class="el-icon-arrow-right btn_right" style="margin-left: 30px;" @click="questionIndex++"
                                v-show="questionIndex < interaction.questions.length - 1"></i>
                        </div>
                        <div class="intercation_modal__answer_result" v-show="[3, 4].includes(answerStep)">
                            {{ interactionAnswer.message }}
                        </div>
                        <div class="intercation_modal__gift" v-show="answerStep == 2">
                            <div class="intercation_modal__gift_top">
                                <div class="intercation_modal__gift_title" v-show="interaction.awardType == 1">{{
                                    interaction.awardPoint }}<span>积分</span></div>
                                <div class="intercation_modal__gift_title2" v-show="interaction.awardType == 2">{{
                                    interaction.awardProduct }}</div>
                            </div>
                            <div class="intercation_modal__gift_bottom">
                                <div class="intercation_modal__gift_desc" v-show="interaction.awardType == 1">
                                    已增加至您的学道账号中
                                </div>
                                <div class="intercation_modal__gift_desc" v-show="interaction.awardType == 2">请留意学道问卷填写领奖信息
                                </div>
                            </div>
                        </div>
                        <!-- <div class="intercation_modal__award_list infinite-list-wrapper" v-show="answerStep == 5"
                                style="overflow: auto;">
                                <p v-if="awardRecord.length==0" style="text-align: center;margin-left:-2.6vw;">暂无用户获奖！</p>
                                <ul v-infinite-scroll="getAwardRecord" infinite-scroll-immediate
                                    infinite-scroll-disabled="disabled">
                                    <div v-for="(item, index) in awardRecord" class="award_table" :key="`record_${index}`">
                                        <div class="award__user">{{ `${index + 1}.` }}{{ item.name }}{{ item.cellphone }}
                                        </div>
                                        <div class="award__date">{{ item.createTime }}</div>
                                    </div>
                                </ul>
                                <p v-if="loading" style="text-align: center;margin-left:-2.6vw;">加载中...</p>
                                <p v-if="noMore && awardRecord.length > 10" style="text-align: center;margin-left:-2.6vw;">
                                    没有更多了
                                </p>
                            </div> -->
                        <el-button v-show="answerStep == 1 && questionIndex > 0"
                            @click="questionIndex--; selected = selects[questionIndex].optionIds"
                            class="intercation_modal__answer last">上一题</el-button>
                        <el-button v-show="answerStep == 1" @click="submitIntercation(interaction, questionIndex)"
                            class="intercation_modal__answer">{{
                                `${questionIndex == interaction.questions.length - 1 ? '完成' : '下一题'}${timeCount < 0 ? '' : '(' +
                                    timeCount + 'S)'}` }}</el-button>
                                <el-button v-show="[3, 4].includes(answerStep)" @click="getAwardRecord();"
                                    class="intercation_modal__answer">{{
                                        `谢谢参与` }}</el-button>
                                <el-button v-show="answerStep == 2" @click="getAwardRecord();"
                                    class="intercation_modal__answer">{{
                                        `开心收下` }}</el-button>
                    </div>
                </div>
                <div id="my-live-control"
                    :style="{ display: 'none', backgroundColor: !isFull ? 'transparent' : 'rgba(0, 0, 0, 0.2)' }">
                    <div class="my-gift-control" v-show="isFull">
                        <div class="gift-controll__item" v-for="gift in giftListReverse" :key="`gift-inner-${gift.id}`"
                            :id="`gift-inner-${gift.id}`" :data-id="gift.id" @click="sendGiftFull($event, gift.id)">
                            <img :src="gift.icon" alt="" />
                            <div class="gift__name">{{ gift.name }}</div>
                            <!-- <el-button class="gift__send" :id="`gift-send-${gift.id}`"
                                    @click="sendGift(gift.id)">赠送</el-button> -->
                        </div>
                    </div>
                    <div class="my-danmu-input-wrapper" v-show="isFull"><el-input id="my_danmu_input" v-model="danmu"
                            @keyup.enter.native="send(danmu)"></el-input></div>
                    <el-button v-show="isFull" id="my-danmu-input__submit" @click="send(danmu)">发送</el-button>
                    <div id="my-record-control" v-show="isFull" @click="showInteraction">
                        <div class="my-icon"></div>
                    </div>
                    <div id="my-danmu-control" class="close">
                        <div class="my-icon outer"></div>
                    </div>
                    <div id="my-volume-control" class="has-voice">
                        <div class="my-icon outer"></div>
                    </div>
                    <div id="my-full-screen-control" class="full">
                        <div class="my-icon outer"></div>
                    </div>
                </div>
            </div>
            <div class="live_player_wrapper">
                <div id="live_player" style="overflow: hidden;" :is-full="isFull">
                </div>
                <div class="live_player___bottom">
                    <div class="info">
                        <div class="headImg"><img :src="info.coverImage || defaultHead" alt="" /></div>
                        <div class="info_wrapper">
                            <div class="info_wrapper__name">{{ info.name }}</div>
                            <div class="info_wrapper__detail"><img alt="" :src="img_view_count" />累计观看：{{
                                viewCount ? viewCount : info.viewCount }}
                                <!-- <span class="share"><img alt="" :src="img_like"
                                        :style="{ filter: info.isLike ? 'unset' : 'grayscale(100%)', cursor: 'pointer' }"
                                        @click="likeLive" />点赞人数：{{ info.likeCount }}</span> -->
                            </div>
                        </div>
                    </div>
                    <div class="gift_list">
                        <div class="gift_item" v-for="gift in giftList" :key="`gift-${gift.id}`" :data-id="gift.id">
                            <img :src="gift.icon" alt="" />
                            <span>{{ gift.name }}</span>
                        </div>
                        <div id="gift_modal" style="position:absolute;top:0;left:0;display:none">
                            <div class="gift_modal_wrapper" @click="sendGift(currentGift)">
                                <img :src="giftList[currentGift - 1].icon" alt="" />
                                <!-- <span>{{ giftList[currentGift - 1].name }}</span> -->
                                <el-button class="gift_send">
                                    <div class="gift_send__inner">赠送{{ clickCount > 0 ?
                                        `+${clickCount}` : ''
                                    }}</div>
                                </el-button>
                            </div>
                        </div>
                    </div>
                    <div class="button_list">
                        <div class="button_item" @click="showInteraction"><img :src="img_answer_record" alt="" />
                            <div class="button__title">抢答记录</div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="live_comment_wrapper">
                <div class="exit-modal" v-show="showExit" @click="exitSubmit">
                    <img alt="" :src="img_exit" />
                    <div>退出登录</div>
                </div>
                <div class="exit-area">
                    <div class="top" @click="showExitHandler">
                        <div class="head-pendant">
                            <img v-if="headPendantUrl" :src="headPendantUrl" alt="" />
                        </div>
                        <div class="head-img">
                            <img :src="headImgUrl || defaultHead" alt="" />
                        </div>
                        <div class="name">{{ userName }}<i
                                :class="showExit ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                        </div>
                    </div>
                    <!-- <el-button @click="exitSubmit" class="btn-exit"><i class="el-icon-s-promotion"></i>退出登录</el-button> -->
                </div>
                <div id="comment-dash" class="live_comment_wrapper__comment">
                    <div id="comment-dash-top" class="live_comment_wrapper__comment_top" v-show="topComments.length > 0">
                        <div v-for="item in topComments" :key="'top' + item.commentId + '' + Math.floor(randomNum(10000))"
                            class="comment_wrapper">
                            <img class="headPendant" v-if="item.imagePendantUrl" :src="item.imagePendantUrl" alt="" />
                            <div class="comment_wrapper_headimg" v-if="!item.eventType"><img :src="item.h5ImageUrl"
                                    alt="" />
                            </div>
                            <div class="comment_wrapper_content" v-if="!item.eventType">
                                <div class="comment__name">{{ item.name }}<span>置顶弹幕</span></div>
                                <div class="comment__content">{{ item.content }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-for="item in comments" :key="item.commentId + '' + Math.floor(randomNum(10000))"
                        class="comment_wrapper">
                        <img :class="!item.eventType?'headPendant':'headPendant gift'" v-if="item.imagePendantUrl" :src="item.imagePendantUrl" alt="" />
                        <div class="comment_wrapper_headimg" v-if="!item.eventType"><img :src="item.h5ImageUrl" alt="" />
                        </div>
                        <div class="comment_wrapper_content" v-if="!item.eventType">
                            <span class="comment__name">{{ item.name }}</span>
                            <div class="comment__content">{{ item.content }}</div>
                        </div>
                        <div class="comment_wrapper_gift" v-if="item.eventType && item.eventType == 'sendGift'">
                            <div class="comment_wrapper_gift__headimg"><img :src="item.h5ImageUrl" alt="" /></div>
                            <div class="comment_wrapper_content">
                                <span class="comment__name">{{ item.accountName }}</span>
                                <div class="comment__gift_name">{{ `赠送 ${item.name}` }}</div>
                            </div>
                            <div class="comment__gift_icon"><img :src="item.icon" alt="" /></div>
                        </div>
                        <div class="comment__gift_count" v-if="item.eventType && item.eventType == 'sendGift'">
                            <span>x</span>{{
                                item.giftCount }}
                        </div>
                    </div>
                </div>
                <div class="live_comment_wrapper__input">
                    <el-input type="textarea" :autosize="false" :resize="'none'" maxLength="200" v-model="message"
                        class="comment_input" placeholder="发个弹幕互动一下吧~" @keyup.enter.native="send">
                    </el-input>
                    <el-button @click="send" class="comment_submit">发送</el-button>
                </div>
            </div>

        </div>

        <div class="detail-describe" v-show="info.description">
            <div class="logo"></div>
            <div class="title">
                直播简介
            </div>
            <div class="content-divide"></div>
            <div class="detail-describe-wrapper">
                <div class="describe" v-html="info.description"></div>
                <!-- <div class="poster"><img :src="info.poster" alt=""></div> -->

            </div>
        </div>
        <div id="player_un_start" style="display:none">
            <div class="error_wrapper">
                <div class="error_content">
                    {{ '直播未开始，请稍后......' }}
                </div>
            </div>
        </div>
        <div id="player_error" style="display:none">
            <div class="error_wrapper">
                <div class="error_content">
                    {{ info.liveStatus == 2 ? '本次直播已结束，感谢您的观看!' : '网络拥堵，请稍后......' }}
                </div>
            </div>
        </div>
        <div id="intercation_tip_modal" style="display: none;" @click="preemptiveAnswer('intercation_tip_modal')">
            <div class="intercation_tip__title">有奖答题</div>
            <div class="intercation_tip__timer">{{ timeDisplay }}</div>
            <el-button class="intercation_tip__answer">立刻答题</el-button>
        </div>
    </div>
</template>
<script>
import Stomp from "stompjs";
import SockJS from "sockjs-client";
import headImg from "../../assets/default_head.png";
import six from "../../../static/image/666/6-10073.png"
import swoosh from "../../../static/image/swoosh/swoosh(2)0050.png"
import aj from "../../assets/aj.png";
import huojian from "../../../static/image/rocket/新火箭(1)0041.png"
import heart from "../../../static/image/goddess2/胜利女神0056.png"
import img_like from "../../../static/image/detail/like@2x.png"
import img_view_count from "../../../static/image/detail/view-count@2x.png"
import img_answer_record from "../../../static/image/detail/answer-record@2x.png"
import img_right from "../../../static/image/detail/right@2x.png"
import img_error from "../../../static/image/detail/close@2x.png"
import img_exit from "../../../static/image/exit@2x.png"
export default {
    data: () => {
        return {
            account: '',
            img_right,
            img_error,
            img_like,
            img_view_count,
            img_answer_record,
            img_exit,
            user: {},
            activeNames: '',
            giftList: [
                {
                    id: 1, name: "火箭", icon: huojian,
                    animationPathPrefix: './static/image/rocket/新火箭(1)00',
                    animationFrames: 42,
                    turn: 1,
                    time: 2,
                },
                {
                    id: 2, name: "666", icon: six,
                    animationPathPrefix: './static/image/666/6-100',
                    animationFrames: 74,
                    time: 2.5,
                },
                {
                    id: 3, name: "AJ", icon: aj,
                    animationPathPrefix: './static/image/aj/A00',
                    animationFrames: 49,
                    time: 2
                },
                {
                    id: 4, name: "JDI", icon: swoosh,
                    animationPathPrefix: './static/image/swoosh/swoosh(2)00',
                    animationFrames: 51,
                    time: 2
                },
                {
                    id: 5, name: "女神", icon: heart,
                    animationPathPrefix: './static/image/goddess2/胜利女神00',
                    animationFrames: 57,
                    time: 2,
                },


            ],
            defaultHead: headImg,
            liveId: 0,
            viewCount: null,
            livePlayer: null,
            info: {},
            danmu: '',
            comments: [],
            topComments: [],
            commentManager: null,
            message: "",
            stompClient: null,
            socketTimer: null,
            // refreshTimer: null,
            token: null,
            playerConf: null,
            playError: 0,
            currentGift: 1,
            clickCount: 0,
            giftCount: {},
            sendGiftTimer: {},
            timeCount: 60,
            startTime: 0,
            targetTime: 0,
            interaction: {
                questions: [{}]
            },
            questionIndex: 0,
            interactionInterval: null,
            preGiftId: null,
            isFull: false,
            damuOpen: true,
            controlDisplayTimer: null,
            selected: [],
            selects: [],
            answerStep: 1,
            showAwardList: false,
            interactionAnswer: {
                questions: [{}]
            },
            loading: false,
            awardTotal: 1,
            awardCount: 0,
            awardRecord: [],
            configs: {},
            fontSize: 0,
            maxWidth: 0,
            maxHeight: 0,
            showInteractionFlag: false,
            interactionPushs: [],
            observer: null,
            recordOldValue: {
                height: '0',
            },
            lastHeight: '100px',
            danmuContainer: {
                width: '0',
                height: '0',
            },
            displayEvent: null,
            showExit: false,
        }
    },
    beforeMount() {

        ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange'].forEach((item, index) => {
            window.removeEventListener(item, () => this.fullChangeHandle())
            window.addEventListener(item, () => this.fullChangeHandle())
        })
    },
    async mounted() {
        let that = this;
        await this.initWaterConfig()
        this.initWaterAnimation()
        // this.$mark({ className: 'detail', text: 'Nike' })
        this.liveId = this.$route.query.liveId
        this.token = CookieManage.get("live-token")
        this.account = CookieManage.get("live-account")
        this.addGiftEvent()
        this.getLiveDetail()
        this.getComments()
        this.initSocket()
    },
    updated() {
        let content = document.querySelector(".describe");
        let fonts = content.querySelectorAll('font')
        let imgs = content.querySelectorAll('img')
        fonts.forEach(i => { i.color = 'black'; i.style.fontSize = '18px'; })
        imgs.forEach(i => { i.style.width = '30%'; i.parentElement.style.textAlign = 'left' })
    },
    computed: {
        userName() {
            return CookieManage.get("live-name") || ''
        },
        headImgUrl() {
            return CookieManage.get('live-headImg') || ''
        },
        headPendantUrl() {
            return CookieManage.get('live-pendant-headImg') || ''
        },
        noMore() {
            return this.awardCount >= this.awardTotal
        },
        giftListReverse: function () {
            let gift = [].concat(this.giftList)
            return gift.reverse();
        },
        timeDisplay: function () {
            return `${(Math.floor(this.timeCount / 3600) + '').padStart(2, 0)}:${(Math.floor(this.timeCount / 60) + '').padStart(2, 0)}:${(Math.floor(this.timeCount % 60) + '').padStart(2, 0)}`
        }
    },
    beforeDestroyed() {
        if (this.observer) {
            this.observer.disconnect()
            this.observer.takeRecords()
            this.observer = null
        }
    },
    destroyed() {
        // 页面销毁关闭定时器
        if (this.socketTimer) {
            clearInterval(this.socketTimer)
        }

        // if (this.refreshTimer) {
        //     clearInterval(this.refreshTimer)
        //     this.refreshTimer = null;
        // }

        this.closeWebsocket();
    },
    methods: {
        handleChange() {

        },
        fullChangeHandle() {
            let interaction_el = this.isFull ? document.getElementById('intercation_tip_modal_inner') : document.getElementById('intercation_tip_modal')

            if (this.isFull && interaction_el.style.display == 'block') {
                let interaction_el2 = this.isFull ? document.getElementById('intercation_tip_modal') : document.getElementById('intercation_tip_modal_inner')
                interaction_el.style.display = 'none'
                interaction_el2.style.display = 'block'
            }

            let isFullScreen = document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen;
            this.isFull = !!isFullScreen;
            // this.isFull = true
            // console.log(this.isFull)
            if (this.preGiftId) {
                // document.getElementById(`gift-send-${this.preGiftId}`).style.display = 'none'
                let preTarget = document.getElementById(`gift-inner-${this.preGiftId}`)
                // preTarget.style.width = '5.2083vw'
                preTarget.style.backgroundColor = "unset"
            }



        },
        exitModalclick() {
            this.showExit = false
            let modal = document.getElementById("exit_modal_wrapper");
            modal.style.display = 'none'
        },
        showExitHandler() {
            this.showExit = !this.showExit
            let modal = document.getElementById("exit_modal_wrapper");
            modal.style.display = this.showExit ? 'block' : 'none'
        },
        exitSubmit() {
            this.showExit = false
            CookieManage.remove('live-account')
            CookieManage.remove('live-token')
            CookieManage.remove('live-name')
            CookieManage.remove('live-headImg')
            CookieManage.remove('live-cellphone')
            // 页面销毁关闭定时器
            if (this.socketTimer) {
                clearInterval(this.socketTimer)
            }

            // if (this.refreshTimer) {
            //     clearInterval(this.refreshTimer)
            //     this.refreshTimer = null;
            // }
            this.closeWebsocket();
            this.$router.push('/login')
        },
        filterLetter(n) {
            switch (n) {
                case 0:
                    return "A";
                case 1:
                    return "B";
                case 2:
                    return "C";
                case 3:
                    return "D";
            }
        },
        randomNum(val) {
            if (val) {
                return crypto.getRandomValues(new Uint8Array(1)) / 255 * val
            }

            return crypto.getRandomValues(new Uint8Array(1)) / 255
        },
        initWaterConfig: async function () {
            let result = await this.$action.live.getConfigs()
            this.configs = result
        },
        addGiftEvent: function () {
            let that = this
            let gifts = document.querySelectorAll(".gift_item")
            let modal = document.getElementById("gift_modal")

            gifts.forEach(g => {
                g.addEventListener("mouseenter", function (e) {
                    let target = e.target;
                    if (e.target.className != 'gift_item') target = e.target.offsetParent;
                    that.currentGift = Number(target.dataset.id);
                    that.clickCount = 0;
                    modal.style.top = '0px'
                    modal.style.left = `${target.offsetLeft - 5}px`
                    modal.style.display = "block"
                }, true)
            })

            modal.addEventListener("mouseleave", function () {
                modal.style.display = "none"
            })

            let animation = document.getElementById("gift_animation");
            if (animation) {
                animation.addEventListener('animationend', (e) => {
                    e.target.style.display = 'none'
                })
            }
        },
        initSocket: function () {
            let that = this;
            let socket = new SockJS("/elearning-live/ws");
            // let socket = new SockJS("http://localhost:81/elearning-live/ws");
            // let socket = new SockJS("https://nikegetit2.nike.com/elearning-live/ws");
            
            this.stompClient = Stomp.over(socket);
            this.stompClient.debug = null
            this.stompClient.connect(
                { token: that.token, liveId: that.liveId, from: "h5", "heart-beat": "0,10000" }, // 传递token
                () => {

                    that.stompClient.subscribe(`/topic/lives/${that.liveId}/view`, (res) => {
                        const rec = JSON.parse(res.body)
                        console.log(rec)
                        that.viewCount = rec
                    })
                    that.stompClient.subscribe(`/topic/lives/${that.liveId}/messages`, (res) => {
                        const rec = JSON.parse(res.body)
                        // console.log(rec)
                        // 处理逻辑
                        if (that.commentManager && rec && rec.isBarrage) {
                            let myMode = Math.ceil(that.randomNum(2))
                            let mode = rec.isTop ? 1 : myMode;
                            let commentInfo = { dbid: rec.commentId, mode, pool: mode, text: rec.content, dur: Math.ceil(that.randomNum(10000) + 8000), color: rec.isTop ? 0xff9617 : 0xffffff, size: rec.isTop ? that.danmuContainer.width / 43.5 : that.danmuContainer.width / 45.5 };
                            if (that.damuOpen) {
                                setTimeout(function () {
                                    that.commentManager.send(commentInfo)
                                }, that.randomNum(1000))
                            }
                        }

                        if (rec && !rec.isBarrage) {
                            let topExist = that.topComments.findIndex(c => c.commentId == rec.commentId);
                            if (!rec.isTop && topExist >= 0) {
                                that.topComments.splice(topExist);
                            }

                            if (rec.isTop && topExist < 0) {
                                let exist = that.comments.findIndex(c => c.commentId == rec.commentId);
                                if (exist >= 0) {
                                  that.comments.splice(exist);
                                }
                                that.topComments.push(rec)
                            }
                        }

                        if (rec && rec.isBarrage) {
                            if (rec.isTop) {
                                let topExist = that.topComments.findIndex(c => c.commentId == rec.commentId);
                                if (topExist == -1) {
                                    that.topComments.push(rec)
                                }
                            }

                            let exist = that.comments.findIndex(c => c.commentId == rec.commentId);
                            if (exist == -1) {
                                that.comments.push(rec)
                            }

                        }

                        setTimeout(function () {
                            let el = document.querySelector("#comment-dash");
                            el.scrollTop = el.scrollHeight;
                            let el2 = document.querySelector("#comment-dash-top");
                            el2.scrollTop = el2.scrollHeight;
                        }, 0)

                    });

                    that.stompClient.subscribe(`/topic/lives/${that.liveId}/gifts`, (res) => {
                        const rec = JSON.parse(res.body)
                        // console.log(rec)
                        // 处理逻辑
                        let gift = this.giftList.filter(g => g.id === rec.giftId)[0];
                        gift.giftId = gift.id;
                        // that.showAnimation(gift)
                        that.comments.push({ commentId:rec.commentId+'-'+rec.giftId, eventType: 'sendGift', giftCount: rec.giftNum, ...gift, h5ImageUrl: rec.h5ImageUrl, imagePendantUrl: rec.imagePendantUrl, accountName: rec.name })
                        setTimeout(function () {
                            let el = document.querySelector("#comment-dash");
                            el.scrollTop = el.scrollHeight;
                        }, 0)
                    });

                    that.stompClient.subscribe(`/topic/lives/${that.liveId}/questions`, (res) => {
                        let interaction_el = that.isFull ? document.getElementById('intercation_tip_modal_inner') : document.getElementById('intercation_tip_modal')
                        // let target = document.getElementById('intercation_modal')

                        const rec = JSON.parse(res.body)
                        // console.log(rec)
                        that.interaction = rec;
                        that.interactionAnswer = rec
                        that.timeCount = rec.answerTime;
                        that.startTime = Date.now()
                        that.targetTime = that.startTime + rec.answerTime * 1000 + 100;
                        interaction_el.style.display = 'block'
                        // that.comments.push({ eventType: 'sendGift', giftCount: rec.giftNum, ...gift, h5ImageUrl: rec.h5ImageUrl, accountName: rec.name })
                        requestAnimationFrame(stamp => {
                            that.interactionInterval = setInterval(function () {
                                that.timeCount = parseInt((that.targetTime - Date.now()) / 1000)
                                if (that.timeCount < 0) {
                                    clearInterval(that.interactionInterval)
                                    interaction_el.style.display = 'none'
                                    // target.style.display = 'none'
                                }
                            }, 999)
                        })

                    });

                    
                    that.stompClient.subscribe(`/topic/lives/${that.liveId}/questions/${that.account}`, (res) => {
                        let interaction_el = that.isFull ? document.getElementById('intercation_tip_modal_inner') : document.getElementById('intercation_tip_modal')
                        // let target = document.getElementById('intercation_modal')

                        const rec = JSON.parse(res.body)
                        // console.log(rec)
                        that.interaction = rec;
                        that.interactionAnswer = rec
                        that.timeCount = rec.answerTime;
                        that.startTime = Date.now()
                        that.targetTime = that.startTime + rec.answerTime * 1000 + 100;
                        interaction_el.style.display = 'block'
                        // that.comments.push({ eventType: 'sendGift', giftCount: rec.giftNum, ...gift, h5ImageUrl: rec.h5ImageUrl, accountName: rec.name })
                        requestAnimationFrame(stamp => {
                            that.interactionInterval = setInterval(function () {
                                that.timeCount = parseInt((that.targetTime - Date.now()) / 1000)
                                if (that.timeCount < 0) {
                                    clearInterval(that.interactionInterval)
                                    interaction_el.style.display = 'none'
                                    // target.style.display = 'none'
                                }
                            }, 999)
                        })

                    });
                },
                (err) => {
                    console.log(err)
                    // 监听报错信息，手动发起重连
                    if (that.socketTimer) {
                        clearInterval(that.socketTimer)
                    }
                    // 1s后重新连接一次
                    that.socketTimer = setTimeout(() => {
                        console.log("开始重联")
                        that.initSocket();
                    }, 1000);
                }
            );
        },
        closeWebsocket: function () {
            if (this.stompClient !== null) {
                this.stompClient.disconnect(() => {
                    console.log("关闭连接");
                });
            }
        },
        getLiveDetail: async function () {
            let that = this;
            let resp = await this.$action.live.getLiveDetail(this.liveId)

            this.info = resp;
            that.loadPlayer()

        },
        getAwardRecord: async function () {
            this.endIntercation()
            // this.loading = true
            // let resp = await this.$action.live.getAwardRecord(this.interaction.packetPushId)

            // this.awardRecord = resp;
            // this.loading = false
            // this.awardTotal = this.awardRecord.length
            // this.awardCount = this.awardRecord.length
        },
        playerControlEventInit: function () {
            let that = this
            // 隐藏自带组件
            let originControl = document.getElementsByClassName('prism-controlbar')[0]
            originControl.classList.add('no-display')
            // 自带组件
            let originVolume = document.getElementsByClassName('prism-volume-control')[0]
            let originFull = document.getElementsByClassName('prism-fullscreen-btn')[0]
            let originDanmuClose = document.getElementsByClassName('icon-danmu-close')[0]
            let originDanmuOpen = document.getElementsByClassName('icon-danmu-open')[0]

            // 我的组件
            let myControl = document.getElementById('my-live-control')
            let myVolume = document.getElementById('my-volume-control')
            let myFull = document.getElementById('my-full-screen-control')
            let myDanmu = document.getElementById('my-danmu-control')

            let livePlayer = document.querySelector('.aliplayer-danmuku .danmu.container')

            livePlayer.addEventListener('mousemove', function () {
                if (!myControl) return;

                myControl.style.display = 'block';
                if (that.controlDisplayTimer) clearInterval(that.controlDisplayTimer)

                that.controlDisplayTimer = setTimeout(function () {
                    myControl.style.display = 'none';
                    clearInterval(that.controlDisplayTimer)
                }, 3000)

            })

            if (myControl) {
                myControl.addEventListener('mouseenter', function (e) {
                    if (!myControl) return;

                    if (that.controlDisplayTimer) clearInterval(that.controlDisplayTimer)
                    myControl.style.display = 'block';

                })
            }

            if (!myControl) return;

            myVolume.getElementsByClassName('my-icon')[0].addEventListener('mousemove', function (e) {
                e.preventDefault()
                if (originVolume.style.display === 'none') {
                    originVolume.style.position = 'absolute'
                    // originVolume.style.float = 'unset'
                    originVolume.style.marginRight = '0'
                    originVolume.style.marginTop = '0'
                    originVolume.style.left = `calc(${myVolume.offsetLeft}px + 0.5vw)`
                    originVolume.style.bottom = `calc(${myVolume.offsetTop}px + 2.7vw)`
                    originVolume.style.display = 'block'
                    // } else {
                    //     originVolume.style.display = 'none'
                }
            })

            myVolume.getElementsByClassName('my-icon')[0].addEventListener('mouseover', function (e) {
                that.displayEvent = setTimeout(function () {
                    originVolume.style.display = 'none'
                }, 1500)
            })

            originVolume.addEventListener('mouseenter', function (e) {
                clearTimeout(that.displayEvent)
            })


            myDanmu.addEventListener('click', function (e) {
                e.preventDefault()
                originVolume.style.display = 'none'
                if (myDanmu.className === 'close') {
                    originDanmuClose.click()
                    myDanmu.className = 'open'
                    that.damuOpen = false
                } else {
                    originDanmuOpen.click()
                    myDanmu.className = 'close'
                    that.damuOpen = true
                }

            })

            myFull.addEventListener('click', function (e) {
                e.preventDefault()
                originVolume.style.display = 'none'
                if (myFull.className === 'full') {
                    if (that.preGiftId) {
                        // document.getElementById(`gift-send-${that.preGiftId}`).style.display = 'none'
                        let preTarget = document.getElementById(`gift-inner-${that.preGiftId}`)
                        preTarget.style.backgroundColor = "unset"
                    }
                    myFull.className = 'un-full'
                } else {
                    myFull.className = 'full'
                }
                originFull.click()
            })

            // 监听音频改动
            let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
            let element = document.querySelector('.volume-value')
            let element_cursor = document.querySelector('.volume-cursor')
            element.style.height = '100%'
            element_cursor.style.bottom = '100%'
            this.observer = new MutationObserver((mutationList) => {
                let height = getComputedStyle(element).getPropertyValue('height')
                if (height === that.recordOldValue.height) return
                that.recordOldValue = {
                    height
                }
                that.livePlayer.setVolume(parseInt(height.replace('px', '')) / 100.00)
                console.log(height)
                if (height == '0px' || height == '0%') {
                    myVolume.className = 'mute'
                } else {
                    myVolume.className = 'has-voice'
                }
            })
            this.observer.observe(element, { attributes: true, attributeFilter: ['style'], attributeOldValue: true })

            this.danmuContainer.width = livePlayer.offsetWidth;
            this.danmuContainer.height = livePlayer.offsetHeight;
            // console.log(this.danmuContainer)


            myVolume.getElementsByClassName('my-icon')[0].addEventListener('click', function (e) {
                // e.preventDefault()
                console.log(e)
                if (myVolume.className == 'mute') {
                    myVolume.className = 'has-voice'
                    element.style.height = that.lastHeight
                    element_cursor.style.bottom = that.lastHeight
                    that.livePlayer.setVolume(parseInt(that.lastHeight.replace('px', '')) / 100.00)
                } else {
                    myVolume.className = 'mute'
                    that.lastHeight = element.style.height
                    element.style.height = '0'
                    element_cursor.style.bottom = '0'
                    that.livePlayer.setVolume(0)
                }
            })

            // document.body.removeEventListener('click', function (e) {
            //     e.preventDefault()
            //     if (e.target.className != 'exit-modal' && e.target.parentElement.className != 'top' && that.showExit) {
            //         that.showExit = false
            //     }
            // })
            // document.body.addEventListener('click', function (e) {
            //     e.preventDefault()
            //     if (e.target.className != 'exit-modal' && e.target.parentElement.className != 'top' && e.target.parentElement.className != 'head-img' && that.showExit) {
            //         that.showExit = false
            //     }
            // }, true)
        },
        // 播放器行为更改
        actionBind: function (player) {
            let that = this;
            // 重写弹幕发送，为调用发送评论接口
            let danmuEnter = document.getElementsByClassName('danmu-input-enter')[0]
            danmuEnter.onclick = null;
            danmuEnter.addEventListener('click', function (e) {
                e.preventDefault()
                // let contentEl = document.querySelectorAll('.ali-danmu-input input')[0];
                // that.send(contentEl.value)
                // contentEl.value = ''
            })

            // 覆盖原有错误展示
            player.on('error', function (e) {
                // this.showInteractionFlag = false;
                let el = document.getElementsByClassName('prism-ErrorMessage')[0];
                let tag = that.info.liveStatus > 0 ? 'player_error' : 'player_un_start';
                el.innerHTML = document.getElementById(tag).innerHTML;
                let myCustom = document.getElementById('my-custom');
                let detail = document.querySelector('.detail');
                detail.appendChild(myCustom);
                myCustom.style.display = 'none'

                setTimeout(function () {
                    that.loadPlayer();
                }, 5000)
                that.playError++

            });

            // 停止重试定时器
            player.on('ready', function (e) {
                that.info.liveStatus = 1;
                that.playError = 0
            });

            // player.on('waiting',function(){
            //     console.log('卡顿')
            // })

            player.on("ended",function(){
                that.info.liveStatus = 2;
                
                let el = document.getElementsByClassName('prism-ErrorMessage')[0];
                let tag = that.info.liveStatus > 0 ? 'player_error' : 'player_un_start';
                el.innerHTML = document.getElementById(tag).innerHTML;
                let myCustom = document.getElementById('my-custom');
                let detail = document.querySelector('.detail');
                detail.appendChild(myCustom);
                myCustom.style.display = 'none'

                setTimeout(function () {
                    that.loadPlayer();
                }, 5000)
                that.playError++
            })
        },
        setMyError: function () {
            let that = this;
            let el = document.getElementsByClassName('prism-ErrorMessage')[0];
            let tag = that.info.liveStatus > 0 ? 'player_error' : 'player_un_start';
            el.innerHTML = document.getElementById(tag).innerHTML;
            setTimeout(function () {
                if (that.playError > 0 || that.info.liveStatus == 0 || that.info.liveStatus == 2) {
                    el.style.display = 'block';
                }
            }, 0)
        },
        // 初始化播放器
        loadPlayer: function () {
            let that = this;
            let liveConf = {
                id: 'live_player',
                source: this.info.videoUrl,
                isLive: true,
                liveRetry: 0,
                components: [{
                    name: 'DanmuComponent',
                    type: AliPlayerComponent.AliplayerDanmuComponent,
                    args: [this.comments]
                }],
                skinLayout: [
                    {
                        name: "bigPlayButton",
                        align: "blabs",
                        x: 30,
                        y: 80
                    },
                    {
                        name: "errorDisplay",
                        align: "tlabs",
                        x: 0,
                        y: 0
                    },
                    {
                        name: "infoDisplay",
                        align: "cc",
                    },
                    {
                        name: "controlBar",
                        align: "blabs",
                        x: 0,
                        y: 0,
                        children: [
                            {
                                name: "liveDisplay",
                                align: "tlabs",
                                x: 15,
                                y: 6
                            },
                            {
                                name: "fullScreenButton",
                                align: "tr",
                                x: 10,
                                y: 10
                            },
                            {
                                name: "volume",
                                align: "tr",
                                x: 5,
                                y: 10
                            }
                        ]
                    }
                ]
            }

            if (!this.livePlayer) {
                this.livePlayer = new Aliplayer(liveConf, function (player) {
                    that.commentManager = player.getComponent('DanmuComponent');
                    let myCustom = document.getElementById('my-custom');
                    let myLivePlayer = document.getElementById('live_player');
                    myLivePlayer.appendChild(myCustom);
                    myCustom.style.display = 'block';
                    that.setMyError()
                })
                that.actionBind(this.livePlayer);
            }
            else {
        
                this.livePlayer.dispose()
                this.livePlayer = null;
                this.livePlayer = new Aliplayer(liveConf, function (player) {
                    that.commentManager = player.getComponent('DanmuComponent');
                    let myCustom = document.getElementById('my-custom');
                    let myLivePlayer = document.getElementById('live_player');
                    myLivePlayer.appendChild(myCustom);
                    myCustom.style.display = 'block';
                    that.setMyError()

                })
                that.actionBind(this.livePlayer);


            }

            that.playerControlEventInit()

        },
        getComments: async function () {
            let resp = await this.$action.live.getLiveComment(this.liveId)
            let commentList = resp ? resp.list : []
            this.topComments = commentList.filter(i => i.isTop)
            this.comments = commentList.filter(i => !i.isTop)
            setTimeout(function () {
                let el = document.querySelector("#comment-dash");
                el.scrollTop = el.scrollHeight;
            }, 0)

        },
        send: async function (content) {
            if (this.message) {
                let text = this.message + "";
                text = text.replaceAll("\\r\\n|\\r|\\n", "")
                this.message = ''
                await this.$action.live.createComment(this.liveId, text)
            }

            if (typeof (content) == 'string' && content) {
                content = content.replaceAll("\\r\\n|\\r|\\n", "")
                await this.$action.live.createComment(this.liveId, content)
                this.danmu = ''
            }

        },
        sendGift: function (id) {
            if (this.clickCount == 99) return;

            let gift = this.giftList.filter(g => g.id === id)[0];

            gift.giftId = gift.id;
            this.showAnimation(gift)

            if (!this.giftCount[`${id}`]) this.giftCount[`${id}`] = 0

            this.giftCount[`${id}`]++;
            this.clickCount++;



            if (this.sendGiftTimer[`${id}`]) clearTimeout(this.sendGiftTimer[`${id}`])

            let that = this;

            this.sendGiftTimer[`${id}`] = setTimeout(function () {
                that.$action.live.sendGift(that.liveId, gift.id, that.giftCount[`${id}`])
                that.giftCount[`${id}`] = 0;
                that.clickCount = 0
                that.sendGiftTimer[`${id}`] = null
            }, 500)
        },
        sendGiftFull: function (e, id) {

            if (e.target.localName === 'span' || e.target.id.startsWith('gift-send')) return;
            if (this.preGiftId) {
                // document.getElementById(`gift-send-${this.preGiftId}`).style.display = 'none'
                let preTarget = document.getElementById(`gift-inner-${this.preGiftId}`)
                preTarget.style.backgroundColor = "unset"
            }
            let target = e.target;
            if (e.target.className != 'gift-controll__item') target = e.target.offsetParent;

            this.preGiftId = target.dataset.id;
            target.style.transition = 'width 0.5s';
            // target.style.width = (['2', '3', '4', '6'].includes(this.preGiftId) ? '8.8675vw' : '7.865vw');
            target.style.backgroundColor = "rgba(255,255,255,0.3)"
            // document.getElementById(`gift-send-${this.preGiftId}`).style.display = 'block'
            this.sendGift(id)
        },
        selectedChange: function (val) {
            if (this.interaction.questions[this.questionIndex].type === 1 && val.length > 1) {
                this.selected = this.selected.slice(1)
            }
        },
        submitIntercation: async function (interaction, index) {
            let useTime = Date.now() - this.startTime;

            if (this.selected.length == 0) {
                this.$message.error("答题选项不能为空！")
                return;
            }

            if (this.selects.length === index) {
                this.selects.push({
                    questionId: interaction.questions[index].questionId,
                    optionIds: JSON.parse(JSON.stringify(this.selected))
                })
            }

            this.selected = []

            if (interaction.questions.length - 1 == index) {

                // console.log(useTime,this.startTime)
                let result = await this.$action.live.submitIntercation(interaction.packetPushId, interaction.packetId, this.selects, useTime)
                if (result) {
                    this.answerStep = result.award ? 2 : result.correct ? 3 : 4
                    this.interactionAnswer = result
                }

                this.selects = [];
                this.questionIndex = 0;
            } else {
                this.questionIndex++;
            }
        },
        likeLive: async function () {
            let result
            if (this.info.isLike) {
                result = await this.$action.live.unLikeLive(this.liveId)
                this.info.likeCount--
                this.info.isLike = false
            } else {
                result = await this.$action.live.likeLive(this.liveId)
                this.info.likeCount++
                this.info.isLike = true
            }
        },
        showAnimation: function (gift) {
            // 判断是否已加入该动画，如存在删除
            let styles = document.styleSheets[0]
            let contain = false;
            for (let i of styles.cssRules) {
                if (i.name == `gift${gift.giftId}`) {
                    contain = true;
                }
            }

            // start 生成动画到css 
            if (!contain) {
                let keyFrame = `@keyframes gift${gift.giftId} { `
                let len = gift.animationFrames;
                for (let i = 0; i < len; i++) {
                    let current = i / len * 100;
                    console.log(gift.animationPathPrefix + ((i + '').padStart(2, '0')) + '.png')
                    keyFrame = keyFrame + `${current.toFixed(1)}% {background-image: url("${gift.animationPathPrefix + ((i + '').padStart(2, '0')) + '.png'}");}`
                }
                keyFrame = keyFrame + "100% {background-image: unset;}"

                styles.insertRule(keyFrame)
            }
            // end

            // 如果当前无动画执行， 展示该动画
            let animation = document.getElementById("gift_animation");
            if (animation && animation.style.display === 'none') {
                animation.style.animation = `gift${gift.giftId} ${gift.time}s`
                animation.style.animationIterationCount = `${gift.turn || 1}`
                animation.style.display = 'block';
            }
        },
        initWaterAnimation: function () {
            let that = this
            this.fontSize = parseInt(this.configs.fontSizeWater);

            this.$mark({ className: 'water_animation', backgroundSize: 'contain', text: CookieManage.get("live-name") + " " + CookieManage.get("live-cellphone"), font_size: this.fontSize, color: this.configs.fontColorWater.substring(1), width: this.fontSize * 14, opacity: this.configs.fontOpacityWater.padStart(2, 0), height: this.fontSize * 1.2, x: 50, y: 56, transform: 'rotate(0, 100 100)' });
            let water = document.getElementsByClassName('water_animation')[0];
            let danmu = document.querySelector('#live_player')

            that.maxWidth = danmu.offsetWidth
            that.maxHeight = danmu.offsetHeight

            setTimeout(() => water.style.display = 'block', 1000)
            // water.style.top = crypto.getRandomValues(new Uint8Array(1)) / 255 * 30 + 'vw';
            requestAnimationFrame(stamp => {
                setInterval(function () {
                    water.style.left = (parseInt(water.style.left.replace('px', '')) + that.maxWidth / 10) + 'px';
                    if (parseInt(water.style.left.replace('px', '')) >= (that.maxWidth - that.fontSize * 14)) {
                        water.style.top = (parseInt(water.style.top.replace('px', '')) + that.fontSize * 1.2) + 'px';
                        water.style.left = '0px'
                    }

                    if (parseInt(water.style.top.replace('px', '')) >= (that.maxHeight - that.fontSize * 1.2)) {
                        water.style.top = '100px'
                        water.style.left = '0px'
                    }

                }, parseInt(that.configs.moveSpeedWater) * 5000)
            })
        },
        preemptiveAnswer: function (item) {

            let interaction_el = document.getElementById(item)
            interaction_el.style.display = 'none'
            // clearInterval(this.interactionInterval)
            // this.interactionInterval = null

            let target = document.getElementById('intercation_modal')
            target.style.display = 'block'

            let modal = this.isFull ? document.getElementById('modal_wrapper_full') : document.getElementById('modal_wrapper')
            modal.style.display = 'block'

        },
        showInteraction: async function () {
            let result = await this.$action.live.getIntercationPush(this.liveId)
            this.interactionPushs = result;
            this.interactionPushs.forEach(p => {
                p.questions.forEach(q => q.selected = q.options.filter(o => o.selected).map(o => o.optionId))
            })
            console.log(this.interactionPushs)
            this.showInteractionFlag = true;
        },
        endIntercation: function () {
            let target = document.getElementById('intercation_modal')
            target.style.display = 'none'

            let modal = this.isFull ? document.getElementById('modal_wrapper_full') : document.getElementById('modal_wrapper')
            modal.style.display = 'none'

            if (this.timeCount == 0) {
                this.interaction = { questions: [{}] }
            }
            this.answerStep = 1
            this.questionIndex = 0
            this.selected = []
            this.selects = []
            this.interactionAnswer = { questions: [{}] };

        }
    }
}
</script>

<style scoped>
.detail {
    width: 100vw;
    /* height: 100vh; */
    display: flex;
}

.live_player___bottom {
    width: 1450px;
    height: 105px;
    min-height: 105px;
    padding: 22px 20px;
    background-color: #111111;
    position: relative;
}

.live_player___bottom .info {
    position: absolute;
    width: 600px;
    display: inline-flex;
}

.live_player___bottom .info .headImg {
    width: 60px;
    height: 60px;
    background-color: #111111;
    clip-path: circle();
}

.live_player___bottom .info .headImg img {
    margin: auto;
    width: 60px;
    height: 60px;
}

.live_player___bottom .info_wrapper {
    margin-left: 10px;
}

.info_wrapper .info_wrapper__name {
    color: white;
    font-size: 26px;
    line-height: 28px;
    width: 500px;
    text-overflow: ellipsis;
    overflow: hidden;
}

.info_wrapper .info_wrapper__detail {
    position: relative;
    margin-top: 7px;
    height: 22px;
    font-size: 16px;
    line-height: 24px;
    color: #98999B;
    width: 500px;
}

.info_wrapper__detail img {
    height: 16px;
    margin: 0 3px 0 0;
    vertical-align: middle;
}

.info_wrapper__detail .share {
    position: absolute;
    left: 200px;
    cursor: pointer;
}



.live_player_wrapper {
    width: 1450px;
    height: calc(1450px / 16 * 9 + 105px);
    background-color: white;
    overflow: hidden;
}

.live_player_wrapper #live_player {
    width: 1450px;
    height: calc(1450px / 16 * 9);
    min-height: calc(1450px / 16 * 9);
    background-color: black;
}

.live_player___bottom .gift_list {
    position: absolute;
    top: 0px;
    right: 144px;
    height: 105px;
    max-width: 560px;
    padding: 0 10px;
    display: inline-flex;
    overflow: hidden;
}

.gift_list .gift_item {
    width: 90px;
    padding: 12px 24px;
    position: relative;
    display: flex;
}

.gift_list .gift_item * {
    cursor: pointer;
}

.gift_list .gift_item img {
    width: 42px;
    height: 42px;
    object-fit: contain;
}

.gift_list .gift_item span {
    position: absolute;
    font-size: 16px;
    line-height: 24px;
    width: 90px;
    left: 0px;
    bottom: 17px;
    text-align: center;
    color: white;
}

#gift_modal {
    box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.3);
    overflow: hidden;
}

.gift_modal_wrapper {
    width: 100px;
    height: 105px;
    background-color: #252632;
    position: relative;
    display: flex;
    text-align: center;
}

.gift_modal_wrapper img {
    width: 100px;
    height: 54px;
    margin-top: 5px;
    padding: 0px 20px;
    object-fit: contain;
}

.gift_modal_wrapper span {
    position: absolute;
    color: white;
    font-size: 18px;
    width: 100px;
    bottom: 40px;
    text-align: center;
}

.gift_modal_wrapper .gift_send {
    position: absolute;
    bottom: 7px;
    left: 12px;
    background-color: #FD5000;
    border-color: #FD5000 !important;
    border-radius: 30px;
    padding: 0 !important;
    width: 76px;
    height: 28px;
    overflow: hidden;
}

.gift_send__inner {
    width: 76px;
    height: 28px;
    text-align: center;
    color: white;
    font-size: 16px;
    line-height: 24px;
}

.live_player___bottom .button_list {
    position: absolute;
    top: 12px;
    right: 0px;
    width: 134px;
    height: 75px;
    border-left: 1px solid #d2d2d2;
}

.button_list .button_item {
    position: relative;
    width: 132px;
    height: 76px;
    padding: 0 30px;
    text-align: center;
    color: white;
    font-size: 16px;
    line-height: 24px;
}

.button_item * {
    cursor: pointer;
}

.button_list .button_item img {
    height: 40px;
}

.button_list .button_item .button__title {
    position: absolute;
    width: 72px;
    bottom: 0px;
}

.live_comment_wrapper {
    position: relative;
    padding: 16px 10px;
    width: 470px;
    height: calc(1450px / 16 * 9 + 105px);
    background-color: white;
    overflow: hidden;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.3);
}

.live_comment_wrapper__comment_top {
    position: sticky;
    margin-left: -10px;
    top: 0px;
    left: 0px;
    width: 470px;
    max-height: 200px;
    padding: 20px 10px;
    overflow-y: auto;
    background-color: white;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    z-index: 3;
}

.exit-modal {
    position: absolute;
    top: 77px;
    left: 10px;
    width: 185px;
    height: 53px;
    background-color: #FFFFFF;
    box-shadow: 0px 0px 12px 1px rgba(0, 0, 0, 0.22);
    padding: 14px 10px;
    z-index: 3;
    font-family: 'nike';
    font-size: 18px;
    display: inline-flex;
    align-items: center;
    z-index: 999;
}

.exit-modal img {
    width: 20px;
    height: 20px;
    /* display: inline-flex; */
    margin-right: 8px;
}

.exit-area {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 470px;
    height: 90px;
    padding: 20px 10px;
    font-size: 18px;
    /* border-bottom: 1px solid rgba(0, 0, 0, 0.1); */
}

.exit-area .top {
    position: absolute;
    left: 10px;
    width: max-content;
    height: 50px;
    text-align: right;
    display: flex;
    /* vertical-align: top; */
}

.exit-area .top .head-img {
    /* display: none; */
    height: 50px;
    width: 50px;
    border-radius: 25px;
    /* border: .5px solid rgba(0, 0, 0, 0.2); */
    overflow: hidden;
}

.exit-area .top .head-img img {
    width: 49px;
    height: 49px;
    object-fit: cover;
}

.exit-area .top .head-pendant{
    position: absolute;
    /* margin-right: -50px; */
    height: 50px;
    width: 50px;
    border-radius: 25px;
    z-index: 2;
    /* border: .5px solid rgba(0, 0, 0, 0.2); */
    /* overflow: hidden; */
}

.exit-area .top .head-pendant img {
    width: 49px;
    height: 49px;
    object-fit: cover;
}


.exit-area .top .name {
    display: block;
    margin-left: 10px;
    margin-top: 12px;
    height: 32px;
    max-width: 378px;
    text-align: left;
    font-size: 18px;
    color: #111111;
    font-weight: 400;
    text-overflow: ellipsis;
    overflow: hidden;
}

.exit-area .top .name i {
    margin-left: 4px;
    font-weight: bold;
}

.exit-area .btn-exit {
    display: none;
    position: absolute;
    top: 10px;
    right: 10px;
    height: 49px;
    padding: 0;
    width: 100px;
    font-size: 18px;
    border-color: transparent;
    border: unset !important;
}

.exit-area .btn-exit.el-button:focus,
.exit-area .btn-exit.el-button:hover {
    top: 0px;
    right: 0px;
    height: 49px;
    padding: 0;
    width: 100px;
    background-color: transparent;
    border-color: transparent;
    border: unset !important;
}

.live_comment_wrapper__comment_top::-webkit-scrollbar {
    width: 0px;
    height: 0px;
}

.live_comment_wrapper__comment {
    position: absolute;
    left: 0px;
    top: 90px;
    width: 470px;
    min-height: 725px;
    height: 725px;
    padding: 0px 10px 10px 10px;
    /* padding-bottom: 10px; */
    overflow-y: auto;
}

.live_comment_wrapper__comment_top>.comment_wrapper:nth-child(1) {
    margin-top: 0;
}

.live_comment_wrapper__comment::-webkit-scrollbar {
    width: 0px;
    height: 0px;
}

#modal_wrapper_full,
#modal_wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    z-index: 888;
}

#exit_modal_wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    z-index: 888;
}

.live_comment_wrapper__comment::-webkit-scrollbar-thumb {
    background-color: #c0c4cc;
}

.live_comment_wrapper__input {
    position: absolute;
    left: 10px;
    bottom: 16px;
    width: 450px;
    height: 85px;
    display: flex;
}

.live_comment_wrapper__input .comment_input {
    position: absolute;
    width: 350px;
    height: 85px;
    font-size: 18px;
    border: 1px solid #111111;
}

.live_comment_wrapper__input .comment_submit {
    position: absolute;
    left: 350px;
    width: 100px;
    height: 85px;
    padding: 0;
    background-color: #111111;
    color: white;
    text-align: center;
    font-size: 18px;
    border: 1px solid #111111;
    border-radius: 0 2px 2px 0;
}

.comment_wrapper {
    margin-top: 20px;
    width: 100%;
    display: flex;
    position: relative;
}

.comment_wrapper img.headPendant{
    position: absolute;
    width: 50px;
    height: 50px;
    z-index: 2;
}

.comment_wrapper_headimg {
    width: 50px;
    height: 50px;
    /* background-color: rgba(0, 0, 0, 0.1); */
    clip-path: circle();
    overflow: hidden;
    display: flex;
}

.comment_wrapper_headimg img {
    margin: auto;
    width: 49px;
    height: 49px;
    object-fit: cover;
}

.comment_wrapper_content {
    margin-left: 6px;
    max-width: 392px;
    font-size: 18px;
}

.comment_wrapper_content .comment__name {
    max-width: 392px;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #797979;
    line-height: 24px;
    font-weight: 400;
}

.live_comment_wrapper__comment_top .comment__name {
    height: 25px;
    display: inline-block;
}

.live_comment_wrapper__comment_top .comment__name span {
    margin-left: 10px;
    color: #111111;
    font-weight: bold;
}

.comment_wrapper_content .comment__content {
    position: relative;
    margin-left: 6px;
    padding: 6px 8px 6px 10px;
    width: fit-content;
    background-color: #f5f5f5;
    word-break: break-all;
    word-wrap: break-word;
    border-radius: 0 20px 20px 20px;
    color: #0F0F0F;
    font-size: 18px;
    line-height: 24px;
}

.comment_wrapper_gift {
    height: 3.125vw;
    background-color: #f4f6f8;
    border-radius: 1.56vw;
    padding: 0.2vw;
    display: flex;
}

.comment_wrapper_gift>.comment_wrapper_content {
    margin-left: 6px;
    max-width: 322px;
    font-size: 18px;
}

.comment_wrapper_gift>.comment_wrapper_content .comment__name {
    word-break: break-all;
    word-wrap: break-word;

}

.comment_wrapper_gift .comment__gift_name {
    font-weight: bold;
    width: max-content;
    padding-left: 12px;
    flex-basis: max-content;
}

.comment_wrapper_gift .comment__gift_icon {
    margin-left: 10px;
    margin-right: 10px;
}

.comment_wrapper_gift .comment__gift_icon img {
    /* margin-top: 0.58125vw; */
    height: 50px;
    width: 50px;
    object-fit: contain;
}

.comment__gift_count {
    height: 60px;
    padding: 10px;
    font-size: 34px;
    color: #98999B
}

.comment_wrapper img.headPendant.gift{
    position: absolute;
    top: 0.2vw;
    left: 0.2vw;
    width: 50px;
    height: 50px;
    z-index: 2;
    /* display: none; */
}

.comment_wrapper_gift__headimg {
    width: 50px;
    height: 50px;
    /* background-color: #111111; */
    clip-path: circle();
    overflow: hidden;
    display: flex;
}

.comment_wrapper_gift__headimg img {
    margin: auto;
    width: 50px;
    height: 50px;
    object-fit: cover;
}

.error_wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.error_wrapper .error_content {
    margin: auto;
    padding: 20px;
    background-color: white;
    opacity: .8;
    border-radius: 5px;
    font-size: 18px;
    user-select: none;
}

#gift_animation {
    z-index: 999999;
    height: 400px;
    width: 400px;
    background-position: 0px 0px;
    background-size: cover;
    background-image: unset;
    background-color: transparent;
    /* animation: mymove 2s; */
    animation-iteration-count: 1;
}

#my-live-control {
    height: 60px;
    width: 100%;
    position: absolute;
    bottom: 0;
    padding: 8px 5px;
}

#my-live-control .my-icon {
    width: 32px;
    height: 32px;
}

.my-icon.outer {
    margin-left: -15px;
    margin-top: -15px;
    width: 63px !important;
    height: 63px !important;
}

#my-full-screen-control {
    position: absolute;
    right: 5px;
    height: 44px;
    width: 62px;
    padding: 6px 16.5px;

}

#my-full-screen-control.full .my-icon {
    width: 29px;
    height: 29px;
    background-image: url("../../../static/image/fullX2.png") !important;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

#my-full-screen-control.un-full .my-icon {
    background-image: url("../../../static/image/close_fullX2.png") !important;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

#my-volume-control {
    position: absolute;
    right: 67px;
    height: 44px;
    width: 65px;
    padding: 6px 15px;
}

#my-volume-control.has-voice .my-icon {
    width: 34px;
    background-image: url("../../../static/image/voiceX2.png") !important;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

#my-volume-control.mute .my-icon {
    width: 34px;
    background-image: url("../../../static/image/mute@2x.png") !important;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

#my-danmu-control {
    position: absolute;
    right: 132px;
    height: 46px;
    width: 63px;
    padding: 6px 14px 6px 15px;
}

#my-danmu-control.close .my-icon {
    background-image: url("../../../static/image/danmuX2.png") !important;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

#my-danmu-control.open .my-icon {
    background-image: url("../../../static/image/close_danmuX2.png") !important;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

#my-record-control {
    position: absolute;
    right: 194px;
    height: 44px;
    width: 60px;
    padding: 6px 15px;
}

#my-record-control .my-icon {
    width: 30px;
    background-image: url("../../../static/image/detail/answer-record@2x.png") !important;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

#my-danmu-input__submit {
    position: absolute;
    right: 270px;
    width: 65px;
    height: 44px;
    background-color: #FD5000;
    text-align: center;
    color: white;
    font-weight: 500;
    font-size: 16px;
    border: unset !important;
    border-radius: 0 !important;
    padding: 0;
}

.my-danmu-input-wrapper {
    position: absolute;
    right: 335px;
    width: 460px;
    height: 44px;
}

.my-gift-control {
    position: absolute;
    right: 815px;
    width: 800px;
    height: 44px;
    display: inline-flex;
    flex-direction: row-reverse;
}

.my-gift-control .gift-controll__item {
    position: relative;
    width: 125px;
    height: 44px;
    margin-left: 10px;
    padding: 2px 6px;
    background-color: transparent;
}

.my-gift-control .gift-controll__item:nth-child(1) {
    width: 100px;
}

.my-gift-control .gift-controll__item:nth-child(2) {
    width: 100px;
}

.my-gift-control .gift-controll__item:nth-child(3) {
    width: 100px;
}

.my-gift-control .gift-controll__item:nth-child(4) {
    width: 100px;
}

.my-gift-control .gift-controll__item:nth-child(5) {
    width: 100px;
}

.gift-controll__item img {
    position: absolute;
    top: 2px;
    left: 6px;
    width: 40px;
    height: 40px;
    object-fit: contain;
}

.gift-controll__item .gift__name {
    position: absolute;
    top: 12px;
    left: 52px;
    height: 44px;
    max-width: fit-content;
    word-break: keep-all;
    color: white;
    font-size: 16px;
    line-height: 16px;
}

.gift-controll__item .gift__send {
    display: none;
    position: absolute;
    top: 7px;
    right: 10px;
    width: 60px;
    height: 30px;
    background-color: #FD5000;
    text-align: center;
    color: white;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px !important;
    border: unset !important;
    border-radius: 0 !important;
    padding: 0;
    transition: width 0.1s;
    cursor: pointer;
}

#intercation_tip_modal {
    position: absolute;
    top: 559px;
    right: -20px;
    /* width: 112px; */
    /* height: 155px; */
    width: 172px;
    height: 198px;
    background-image: url("../../../static/image/detail/question-tip@2x.png");
    background-repeat: no-repeat;
    background-size: contain;
    padding: 12.5px 28px;
}


#intercation_tip_modal_inner {
    position: absolute;
    right: -20px;
    /* width: 112px; */
    /* height: 155px; */
    width: 172px;
    height: 198px;
    background-image: url("../../../static/image/detail/question-tip@2x.png");
    background-repeat: no-repeat;
    background-size: contain;
    padding: 12.5px 28px;
    bottom: 100px;
}

#intercation_tip_modal .intercation_tip__title,
#intercation_tip_modal_inner .intercation_tip__title {
    width: 112px;
    height: 20px;
    margin-top: 31px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #0F0F0F;
}

#intercation_tip_modal .intercation_tip__timer,
#intercation_tip_modal_inner .intercation_tip__timer {
    margin-top: 21px;
    height: 39px;
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: #111111;
}

#intercation_tip_modal .intercation_tip__answer,
#intercation_tip_modal_inner .intercation_tip__answer {
    margin-top: 8px;
    margin-left: 18px;
    width: 76px;
    height: 26px;
    background-color: #111111;
    border-radius: 33px;
    box-shadow: 0px 5px 3px 1px #D8A48C;
    padding: 0;
    color: white;
}

#intercation_modal {
    position: absolute;
    top: 160.625px;
    left: 761.9375px;
    width: 397.125px;
    height: 618.75px;
    background-image: url("../../../static/image/detail/question.png");
    background-repeat: no-repeat;
    background-size: contain;
    z-index: 9999;
}

#intercation_modal.answer {
    position: absolute;
    top: 160.625px;
    left: 761.9375px;
    width: 397.125px;
    height: 618.75px;
    background-image: url("../../../static/image/detail/question2@2x.png") !important;
    background-repeat: no-repeat;
    background-size: contain;
    z-index: 9999;
}

.title_container {
    position: absolute;
    top: 100.125px;
    height: 95.625px;
    width: 397.125px;
    display: flex;
}

.intercation_modal__title {
    margin: auto;
    top: 131.625px;
    width: 397.125px;
    padding: 0 45px;
    font-size: 18px;
    font-weight: bold;
    word-break: break-all;
}

.intercation_modal__options,
.intercation_modal__answer_options {
    position: absolute;
    top: 195.75px;
    width: 397.125px;
    padding: 7.875px 48px;
}

.intercation_modal__option {
    margin-top: 14px;
    width: 100%;
    font-size: 16px;
    font-weight: bold;
}

.intercation_modal__answer_options .intercation_modal__option {
    margin-top: 14px;
    display: inline-flex;
}


.intercation_modal__answer_options .intercation_modal__option .right {
    margin-top: 3.5px;
    margin-right: 10px;
    width: 13.5px;
    height: 13.5px;
    display: flex;
}

.intercation_modal__answer_options .intercation_modal__option .right img {
    width: 13.5px;
    object-fit: contain;
}

.intercation_modal__answer_options .intercation_modal__option .error {
    margin-top: 3.5px;
    margin-right: 10px;
    width: 13.5px;
    height: 13.5px;
    display: flex;
}

.intercation_modal__answer_options .intercation_modal__option .error img {
    width: 13.5px;
    object-fit: contain;
}

.intercation_modal__answer_result {
    position: absolute;
    bottom: 147.375px;
    width: 397.125px;
    height: 29px;
    text-align: center;
    font-size: 20px;
    line-height: 28px;
}

.intercation_modal__answer_result_change {
    position: absolute;
    bottom: 275px;
    width: 397.125px;
    height: 29px;
    text-align: center;
    font-size: 28px;
    font-weight: 900;
    line-height: 28px;
}

.intercation_modal__answer_result_change .btn_left {
    position: absolute;
    left: 10px;
}

.intercation_modal__answer_result_change .btn_right {
    position: absolute;
    right: 10px;
}

.intercation_modal__answer_result_change>i:hover {
    color: white;
}

.intercation_modal__gift {
    position: absolute;
    left: 60.75px;
    bottom: 201.375px;
    width: 275.625px;
    height: 199.125px;
    background-image: url("../../../static/image/detail/gift-bg@2x.png");
    background-repeat: no-repeat;
    background-size: contain;
}

.intercation_modal__gift_top {
    width: 275.625px;
    height: 105.75px;
    display: flex;
}

.intercation_modal__gift_bottom {
    width: 275.625px;
    height: 91.125px;
    display: flex;
}

.intercation_modal__gift_title,
.intercation_modal__gift_title2 {
    margin: auto;
    width: 275.625px;
    background-color: transparent;
    text-align: center;
    font-size: 44px;
    color: #111111;
    text-overflow: ellipsis;
    overflow: hidden;
}

.intercation_modal__gift_title2 {
    font-size: 22px;
    font-weight: bold;
}


.intercation_modal__gift_title span {
    font-size: 14px;
}

.intercation_modal__gift_desc {
    margin: auto;
    width: 275.625px;
    text-align: center;
    font-size: 14px;
}

.intercation_modal__award_list {
    position: absolute;
    bottom: 72px;
    width: 347px;
    height: 280px;
    padding-left: 40px;
    overflow-x: hidden;
}

.intercation_modal__award_list::-webkit-scrollbar {
    width: 4px;
    height: 0px;
}

.intercation_modal__award_list::-webkit-scrollbar-thumb {
    background-color: #FCFEF6;
}

.award_table {
    display: inline-flex;
    height: 20px;
    width: 100%;
    position: relative;
    margin-bottom: 5px;
}

.award__user {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 175px;
    height: 20px;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
}

.award__date {
    position: absolute;
    top: 1px;
    left: 180px;
    width: 100px;
    height: 20px;
}

.intercation_modal__answer,
.intercation_modal__answer:focus {
    position: absolute;
    top: 479.25px;
    left: 104.625px;
    width: 187.875px;
    height: 44px;
    padding: 0;
    margin: 0 !important;
    border-radius: 33px;
    background-color: #111111;
    color: white;
    font-size: 18px;
    font-weight: bold;
}



.intercation_modal__answer:hover {
    position: absolute;
    top: 479.25px;
    left: 104.625px;
    width: 187.875px;
    height: 44px;
    padding: 0;
    margin: 0 !important;
    border-radius: 33px;
    background-color: #111111;
    color: #FD5000;
    font-size: 18px;
    font-weight: bold;
}

.intercation_modal__answer.last {
    top: 429.25px
}

.intercation_modal__close {
    position: absolute;
    bottom: 0;
    left: 182.25px;
    width: 30px;
    height: 30px;
    color: white;
    font-size: 30px;
    background-image: url("../../../static/image/close-modal@2x.png");
    background-size: contain;
    background-repeat: no-repeat;
}

.detail-describe {
    width: 1920px;
    /* height: 1289.5px; */
    padding: 30px 100px;
    background-image: url('../../../static/image/common/background-water.png');
    background-size: contain;
}

.detail-describe .logo {
    margin-top: 40px;
    width: 100px;
    height: 36px;
    background-image: url('../../../static/image/common/Nike-logo-2@2x.png');
    background-size: cover;
}

.detail-describe .title {
    margin-top: 11px;
    width: 128px;
    height: 45px;
    font-size: 32px;
    color: #111111;
    font-weight: bold;
}

.detail-describe .content-divide {
    margin: 11px 0;
    border: 1px solid #111111;
}

.detail-describe .detail-describe-wrapper {
    width: 1720px;
    /* height: 1119px; */
    background-color: transparent;
}

.detail-describe-wrapper .poster {
    width: 100%;
}

.detail-describe-wrapper .poster img {
    object-fit: contain;
    width: 100%;
}

.detail-describe-wrapper .describe {
    width: 100%;
    /* height: 1119px; */
    font-size: 22px;
    font-weight: bold;
    padding: 30px;
}

.detail-describe-wrapper .describe p>font {
    color: black !important;
}

.interaction-log {
    width: 100%;
    height: 727px;
    position: relative;
    padding: 20px;
}

.interaction-log .logo {
    position: absolute;
    top: 30px;
    left: 50px;
    width: 100px;
    height: 36px;
    background-image: url('../../../static/image/common/Nike-logo-2@2x.png');
    background-size: cover;
}

.interaction-log .title {
    position: absolute;
    top: 77px;
    left: 50px;
    width: 96px;
    height: 44px;
    font-size: 24px;
    font-weight: bold;
}

.interaction-log .title-container {
    height: 44px;
    width: 80%;
    font-size: 18px;
    font-weight: bold;
    display: inline-flex;
    text-overflow: ellipsis;
    overflow: hidden;
}

.interaction-log .close {
    position: absolute;
    top: 39px;
    right: 30px;
    width: 20px;
    height: 20px;
    background-image: url('../../../static/image/detail/close@2x.png');
    background-size: cover;
}

.interaction-log .list-wrapper {
    margin-top: 100px;
    width: 100%;
    height: 557px;
    overflow-x: hidden;
}

.interaction-log .list-wrapper::-webkit-scrollbar {
    width: 11px;
    height: 0px;
}

.list-wrapper .list-item {
    margin-top: 30px;
    font-size: 18px;
    font-weight: bold;
    color: #111111;
}

.list-wrapper .list-item-content {
    margin-top: 10px;
    padding: 20px;
    background-color: #F5F5F5;
    color: #888888;
    font-size: 18px;

}

.interaction-log .list-wrapper::-webkit-scrollbar-thumb {
    background-color: #F5F5F5;
    border-radius: 6px;
}

.list-wrapper .intercation_modal__option {
    font-size: 18px;
    margin-top: 20px;
    position: relative;
}

.list-wrapper .intercation_modal__option .right {
    position: absolute;
    top: 7px;
    right: 0px;
    width: 14px;
    height: 12px;
    background-image: url('../../../static/image/detail/right@2x.png');
    background-size: cover;
    background-repeat: no-repeat;
}

.list-wrapper .intercation_modal__option .error {
    position: absolute;
    top: 7px;
    right: 0px;
    width: 12px;
    height: 12px;
    background-image: url('../../../static/image/detail/close@2x.png');
    background-size: cover;
    background-repeat: no-repeat;
}
</style>

<style>
#interaction-log .el-dialog {
    margin-top: 127px !important;
}

#interaction-log .el-dialog__header {
    display: none;
}

#interaction-log .el-dialog__body {
    padding: 0 !important;
}

.gift-controll__item .gift__send>span {
    cursor: pointer !important;
}

.gift_send>span {
    cursor: pointer !important;
}

.intercation_modal__option .el-checkbox {
    color: #111111;
}

.list-wrapper .intercation_modal__option .el-checkbox {
    color: #888888;
}

.intercation_modal__option .el-checkbox__inner {
    background-color: transparent;
    border: solid 2px #111111;
    width: 12px;
    height: 12px;
    margin: 2px;
    border-radius: 6px;
}

.list-wrapper .intercation_modal__option .el-checkbox__inner {
    background-color: transparent;
    border: solid 2px #C9C9C9;
    width: 12px;
    height: 12px;
    margin: 2px;
    border-radius: 6px;
}

.intercation_modal__option .el-avatar,
.intercation_modal__option .el-cascader-panel,
.intercation_modal__option .el-checkbox,
.intercation_modal__option .el-checkbox--medium.is-bordered .el-checkbox__label,
.intercation_modal__option .el-checkbox__label {
    font-size: 16px;
    font-weight: bold;
    white-space: normal;
    display: inline-flex;
}

.intercation_modal__option .el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #111111;
}

.list-wrapper .intercation_modal__option .el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #888888;
}

.intercation_modal__option .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #111111;
}

.list-wrapper .intercation_modal__option .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #888888;
}

.intercation_modal__option .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #111111;
    background-color: transparent;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    margin: 0px;
}

.list-wrapper .intercation_modal__option .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #C9C9C9;
    background-color: transparent;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    margin: 0px;
}


.intercation_modal__option .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #111111;
}


.list-wrapper .intercation_modal__option .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #C9C9C9;
}

.intercation_modal__option .el-checkbox__input .el-checkbox__inner::after {
    background-color: #111111;
    transform: translate(-50%, -50%) scale(1) !important;
    top: 50%;
    left: 50%;
    display: none;
}



.list-wrapper .intercation_modal__option .el-checkbox__input .el-checkbox__inner::after {
    background-color: #C9C9C9;
    transform: translate(-50%, -50%) scale(1) !important;
    top: 50%;
    left: 50%;
    display: none;
}

.intercation_modal__option .el-checkbox__input.is-checked .el-checkbox__inner::after {
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    border-color: transparent;
    background-color: #111111;
}

.list-wrapper .intercation_modal__option .el-checkbox__input.is-checked .el-checkbox__inner::after {
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    border-color: transparent;
    background-color: #c9C9C9;
}

.live_comment_wrapper__input .el-textarea__inner {
    padding: 10px;
    height: 80px;
    border: unset !important;
}

.comment_submit>span {
    cursor: pointer !important;
}

.prism-controlbar {
    display: none !important;
}

.prism-setting-speed {
    display: none !important;
}

.prism-live-display {
    display: none !important;
}

.ali-danmu-input-wrap {
    display: none !important;
}

.prism-big-play-btn {
    left: 48% !important;
    top: 48% !important;
}

.ali-danmuku-control {
    display: none !important;
}

.prism-volume {
    display: none !important;
}

.prism-fullscreen-btn {
    display: none !important;
}

.aliplayer-danmuku{
    top: 5% !important;
    height: 90% !important;
}

#live_player[is-full=true] .aliplayer-danmuku {
    top: 5% !important;
    height: 90% !important;
}

.my-danmu-input-wrapper .el-input {
    width: 460px !important;
    height: 44px !important;
}

.my-danmu-input-wrapper .el-input__inner {
    border-color: #FD5000;
    background-color: transparent;
    border-radius: 0;
    width: 460px !important;
    height: 44px !important;
    font-size: 16px;
    font-weight: 500;
    color: white;
}

.prism-info-display {
    display: none !important;
}

.no-display {
    display: none !important;
}

.danmu.container .cmt {
    opacity: 0.8;
    text-shadow: rgba(0, 0, 0, .8) 1px 0 0, rgba(0, 0, 0, .8) 0 1px 0, rgba(0, 0, 0, .8) -1px 0 0, rgba(0, 0, 0, .8) 0 -1px 0;
    -webkit-app-region: no-drag;
    line-height: 1.4 !important;
    padding: 5px 0 !important;
}

.danmu__custom {
    font-size: 0.9896vw !important;
    color: rgba(255, 255, 255, 0.85);
    text-shadow: rgba(0, 0, 0, .8) 1px 0 0, rgba(0, 0, 0, .8) 0 1px 0, rgba(0, 0, 0, .8) -1px 0 0, rgba(0, 0, 0, .8) 0 -1px 0;
    -webkit-app-region: no-drag;
}

.danmu__important {
    font-size: 1.198vw !important;
    color: rgba(255, 150, 23, 0.85);
    text-shadow: rgba(0, 0, 0, .8) 1px 0 0, rgba(0, 0, 0, .8) 0 1px 0, rgba(0, 0, 0, .8) -1px 0 0, rgba(0, 0, 0, .8) 0 -1px 0;
    -webkit-app-region: no-drag;
}
</style>


// WEBPACK FOOTER //
// src/pages/live/detail.vue